import { ErrorMessage } from "#root/components/alert";
import { Form } from "#root/components/form";
import * as Fields from "#root/components/form/fields";
import { setCrossRequestData } from "#root/utility/cross-request-data";
import cookies from "browser-cookies";
import type { ReactNode } from "react";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { contactCollection, type ContactDetailItem } from "../schema/contact";
import PageLayout from "./layout";

export default function (): ReactNode {
  const navigate = useNavigate();
  const [message, setMessage] = useState<ReactNode | null>(null);

  const data = useMemo(
    () => ({
      affiliate: cookies.get("affiliate"),
    } as ContactDetailItem),
    [],
  );

  const handleSubmit = useCallback(
    async (data: ContactDetailItem) => {
      try {
        await contactCollection.add(data);
        setCrossRequestData(data);
        navigate("/contact/complete");
      } catch (error: any) {
        setMessage(<ErrorMessage error/>);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="Contact Us">
      <section
        className="flex-none m-0 flex justify-center bg-cover bg-center"
        style={{
          background:
            "linear-gradient(90deg, rgb(0 0 0 / 0.5), rgb(0 0 0 / 0.3)), url(\"/images/bg3.webp\") center / cover",
        }}
      >
        <div className="text-white w-full max-w-200 py-16">
          <h1 className="border-b-0 text-white text-4xl m-0">Contact Us</h1>
          <p className="text-white text-xl my-[0.8rem]">We'd love to hear from you</p>
        </div>
      </section>

      <section className="flex-none m-0 px-8 py-16 bg-[#f9f9fb]">
        <div className="max-w-4xl mx-auto bg-white border border-[#eee] rounded-lg shadow-[0_2px_8px_rgb(0_0_0/0.06)] p-12">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-[#1a1a2e] m-0 mb-2">Get in touch</h2>
            <p className="text-[#666] text-base m-0">To try out or to subscribe to any API, please fill out the form below, or call us at <a
              href="tel:888-688-9880">(888) 688-9880</a></p>
          </div>
          <Form data={data} onSubmit={handleSubmit}>
            {message}
            <Fields.Set name="affiliate">
              <Fields.Hidden/>
            </Fields.Set>
            <div className="grid grid-cols-2 gap-x-8">
              <Fields.Set name="email">
                <label>Your Email Address</label>
                <Fields.Email dirty required autoComplete="email"/>
                <Fields.Validity/>
              </Fields.Set>
              <Fields.Set name="name">
                <label>Your Full Name</label>
                <Fields.FullName autoComplete="name"/>
                <Fields.Validity/>
              </Fields.Set>
              <Fields.Set name="company">
                <label>Company Name</label>
                <Fields.CompanyName autoComplete="organization"/>
                <Fields.Validity/>
              </Fields.Set>
              <Fields.Set name="phone">
                <label>Phone Number</label>
                <Fields.Phone autoComplete="tel"/>
                <Fields.Validity/>
              </Fields.Set>
            </div>
            <Fields.Set name="needs">
              <label>Tell us about your needs</label>
              <Fields.TextArea rows={5}/>
              <Fields.Validity/>
            </Fields.Set>
            <div className="button-row">
              <Fields.Submit>Submit</Fields.Submit>
            </div>
          </Form>
        </div>
      </section>
    </PageLayout>
  );
}
